<!--
 * @Author: your name
 * @Date: 2021-08-23 01:32:45
 * @LastEditTime: 2021-09-07 21:14:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /private-claim/src/components/Provinces.vue
-->
<template>
  <div class="provinces">
    <van-field
      readonly
      clickable
      name="area"
      label="请选择省市区"
      placeholder="请选择省市区"
      :value="value"
      @click="showArea = true"
      :rules="[{ required: required }]"
    />
    <van-popup v-model="showArea" position="bottom" round>
      <van-area
        :area-list="areaList"
        :value="value1"
        title="省市区选择"
        @confirm="onConfirm"
        @cancel="showArea = false"
      />
    </van-popup>
  </div>
</template>

<script>
import areaList from "./area";
export default {
  name: "FormWithProvinces",
  props: {
    required: {
      type: Boolean,
      default: true,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      areaList: Object.freeze(areaList),
      showLoading: false,
      value: "",
      value1: "",
      showArea: false,
      pname: "", //省名称-pname
      pid: "", //省id-pid
      cname: "", //市名称-cname
      cid: "", //市id-cid
      dname: "", //区名称-dname
      did: "", //区id-did
      columns: [], //当前地址列表
    };
  },
  watch: {
    form: {
      handler(newVal) {
        if (newVal.pname) {
          this.pname = newVal.pname;
          this.pid = newVal.pid;
          this.cname = newVal.cname;
          this.cid = newVal.cid;
          this.dname = newVal.dname;
          this.did = newVal.did;
          this.value = newVal.pname + "-" + newVal.cname + "-" + newVal.dname;
          this.value1 = this.did + "";
        }
      },
      immediate: true,
    },
  },
  methods: {
    onConfirm([p, c, d]) {
      this.pname = p.name;
      this.pid = p.code;
      this.cname = c.name;
      this.cid = c.code;
      this.dname = d.name;
      this.did = d.code;
      this.value = this.pname + "-" + this.cname + "-" + this.dname;
      this.value1 = this.did + "";
      this.showArea = false;
    },
    // 验证并返回数据
    verify() {
      let data = false;
      if (this.value) {
        data = {
          pname: this.pname,
          cname: this.cname,
          dname: this.dname,
          pid: this.pid,
          cid: this.cid,
          did: this.did,
        };
      }
      return data;
    },
  },
};
</script>

<style lang="less" scoped>
.provinces {
  .vue-provinces-div {
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    white-space: normal;
  }
  .vue-provinces-div:empty::before {
    content: attr(placeholder);
    font-size: 12px;
    color: #ccc;
  }
}
</style>
